import React from 'react';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger';
import {Image} from '@learningblocks/shared-components/lib/Image';

import styles from './style.module.scss';
import { SolutionTube } from '@learningblocks/storybook-components/lib/ProtocolComponents/SolutionTube';
import { GlossaryProvider } from '@learningblocks/storybook-components/lib/GlossaryProvider';


export function MaterialCard(props) {
  const [open, setOpen] = React.useState(null);
  const { onOpenGlossary } = React.useContext(GlossaryProvider.Context);

  const toggleSlide = () => {
    setOpen((slideOpen) => !slideOpen)
  };

  const renderImage = () => {
    const ariaLabel = (props.ariaLabel) ? props.ariaLabel : props.fullName;
    if (props.isSolutionTube) {
      return <div className={styles.materialcard__imageBlock}>
        <SolutionTube
          title={ariaLabel}
          isOpen={false}
          id={props.id}
          size={props.solutionTube.size}
          type={props.solutionTube.type}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          toggleOpen={() => { }}
          solution={
            {
              solutionColor: props.solutionTube.solutionColor,
              circleColor: props.solutionTube.circleColor,
              circleOutline: props.solutionTube.circleOutline,
              isOpen: false,
              label: props.solutionTube.label,
            }
          }
        />
      </div>
    }
    if (props.imageComponent) {
      return (
        <div className={styles.materialcard__imageBlock}>{props.imageComponent}</div>
      );
    } else {
      return (
        <div id={"materialcard__image" + props.fullName} style={{ backgroundColor: '#003e6b', margin: 'auto', padding: 'auto' }}>
          <Image
            style={{ ...props.imageStyle }}
            src={props.image}
            alt={props.fullName}
            className={styles.materialcard__image}
          />
        </div>
      );
    }
  };

  const renderGlossaryLink = () => {
    if (props.contentID) {
      return (<LogEvent
          logEventProps={{
            event_type: "sim_material_term_read_more clicked",
            event_schema: "term",
            term: fullName.replace(/<[^>]+>/g, ''),
            glossary_id: props.contentID
          }}
          actionProps={{ onClick: { action: 'click' } }}
          elementType="button"
        >
          <div
            style={{ lineHeight: 1.5, color: "#fff" }}
            tabIndex={0}
            role="button"
            onClick={(e) => {
              e.stopPropagation();
              onOpenGlossary(props.contentID);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
                onOpenGlossary(props.contentID);
              }
            }}
          >
            <p>Read more</p>
          </div>
        </LogEvent>)
    }
  }

  const { fullName, description } = props;

  return (
    <div className={styles.materialcard}>
      <LogEvent
        logEventProps={{
          event_type: "sim_material_term viewed",
          event_schema: "term",
          term: fullName.replace(/<[^>]+>/g, ''),
          glossary_id: props.contentID
        }}
        actionProps={{ onClick: { action: 'click' } }}
        elementType="button"
      >
          <button className={styles.materialcard__button} onClick={toggleSlide} >
            <div aria-hidden={open ? 'true' : 'false'} aria-live='polite' aria-atomic='true'>
              {renderImage()}
            </div>
            <div className={styles.materialcard__titleblock} aria-hidden='true'>
              <p className={styles.materialcard__titleblock_text}>{parse(fullName)}</p>
            </div>
          </button>
      </LogEvent>
      <div
        tabIndex={0}
        role="button"
        className={`${styles.materialcard__slideblock} ${open !== null ? (open ? styles.open : styles.closed) : ''}`}
        onClick={toggleSlide}
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            toggleSlide();
          }
        }}
        aria-hidden={open ? 'false' : 'true'}
        aria-live="polite"
        aria-atomic="true"
      >
        <p className={styles.materialcard__slideblock_title} aria-hidden="true">
          {parse(fullName)}
        </p>
        <p className={styles.materialcard__slideblock_text}>{parse(description)}</p>
        {renderGlossaryLink()}
      </div>
    </div>
  );
}

MaterialCard.propTypes = {
  /**
   * Url for image to be displayed on widget
   */
  image: PropTypes.string,
  /**
   * Title for the widget
   */
  title: PropTypes.string,
  /**
   * description for the widget
   */
  description: PropTypes.string,
  /**
   * React component to display instead of image [ Overrided image prop]
   */
  imageComponent: PropTypes.element || null,

  hassolutionTube: PropTypes.bool,

  solutionTube: PropTypes.any
};

MaterialCard.defaultProps = {
  imageComponent: null,
};

export { Tube } from './Tube';
